export default __webpack_public_path__ + "static/Vishal-Patel-Software-Developer-2021-3d7d4b3bb96a68b46a84284bc0676589.pdf";